import axiosInstance from './axiosInstance';
import Base_URL from '../config/apiConfig';

const API_URL = `${Base_URL}/projects/`;

// Fetch all projects
export const fetchProjects = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

// Create a new project
export const createProject = async (newProjectData) => {
    const response = await axiosInstance.post(API_URL, newProjectData);
    return response.data;
  };

export const deleteProjectAPI = async (projectId) => {
  const response = await axiosInstance.delete(`/projects/${projectId}`);
  return response.data;
};

// Update project starring status
export const updateProjectStarring = async (projectId, isStarred) => {
  const response = await axiosInstance.patch(`/projects/${projectId}`, {
    is_starred: isStarred
  });
  return response.data;
};